import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateDocumentTitle } from '../utils/documentTitle';

/** Sets browser tab title from the current route (page name | HireVeda). */
export function useDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    updateDocumentTitle(pathname);
  }, [pathname]);
}
